export const getId = (gameData) =>
  btoa(gameData.grid.join(''));

export const save = ({ gameData, gameState }) => {
  const id = getId(gameData);
  const guesses = gameState.guesses.join('');
  localStorage.setItem(`save/${id}`, guesses);
  localStorage.setItem(`data/${id}`, JSON.stringify({
    ...gameData, moves: undefined
  }));
  return id;
};

export const open = id => {
  const packedGameData = localStorage.getItem(`data/${id}`);
  const packedGuesses = localStorage.getItem(`save/${id}`);
  if (!packedGameData) return {};
  const gameData = JSON.parse(packedGameData);
  const guesses = packedGuesses.split('');

  return { gameData, gameState: { guesses }};
};


export const ids = () => Object.keys(localStorage).reduce(
  (idMap, path) => localStorage.hasOwnProperty(path) && path.startsWith('save')
    ? ({ ...idMap, [path.split('/').findLast(() => true)]: true })
    : idMap,
  {}
);

export const directory = () => localStorage.getItem('directory') || '';

export const saveDirectory = newDirectory => {
  localStorage.setItem('directory', newDirectory);
  return 'directory';
}
